import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { loadAction } from "redux/reducers/top";
import { renderNoti, goMegaMall } from "assets/js/common";
import { Box, Button, Collapse } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import ReviewComment from "components/product-of-week/review-comment";
import Loading from "components/ui/loading";
import { loadAlert, loadHideAlert } from "redux/reducers/top";
import { Cookies } from "react-cookie";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import AlertComplete from "components/ui/alert-complete";
import { openMagamartMall } from "assets/js/apphandle";

const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  productWeek: {
    "& .btn-wrap": {
      "& .btn-rounded.MuiButton-outlinedSizeSmall": {
        borderColor: theme.palette.common.black,
        color: theme.palette.text.primary,
        "&.end-icon": {
          "& .ico-go": {
            width: rem(18),
            height: rem(18),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/arrow-selectbox.svg)`,
            transform: "rotate(-180deg)",
            marginBottom: rem(2),
          },
        },
      },
    },
    "& .btn-wrap.fade-box": {
      "& .btn-rounded.MuiButton-outlinedSizeSmall": {
        "&.end-icon": {
          "& .ico-go": {
            transform: "rotate(0)",
          },
        },
      },
    },
  },
}));

export default function ProductOfWeekDetail() {
  const favInfo = cookies.get("favInfo");

  let { seq } = useParams();

  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  const [detailData, setDetailData] = useState("");
  const [checked, setChecked] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [token, setToken] = useState("");
  const [open, setOpen] = useState(false);
  const [descImgChecked, setDescImgChecked] = useState(false);

  useEffect(() => {
    setFetching(true);
    setToken(cookies.get("X-AUTH-TOKEN"));
    window.scrollTo(0, 0);
    loadDetail();
  }, []);

  const { init, alertOpen } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "상품 상세정보", menu: false }));
  }, [init]);

  const handleAlertClose = () => {
    setOpen(false);
  };

  const loadDetail = () => {
    return new Promise((resolve) => {
      axios
        .get(`/api/eh/product/get/${seq}`)
        .then((res) => {
          setDetailData(res.data.data.product);
          if (res.data.data.product && res.data.data.product.prodDescImgUrl)
            checkImgSize(res.data.data.product.prodDescImgUrl);
          resolve(res.data.data);
          setFetching(false);
        })
        .catch((error) => {
          setFetching(false);
        });
    });
  };

  const handleFav = () => {
    if (token) {
      axios
        .post(`/api/eh/product/favorite/fav`, {
          seq: detailData.seq,
        })
        .then((res) => {
          loadDetail();
        });
    } else {
      dispatch(loadAlert(true));
    }
  };

  const buyItem = (cd) => {
    if (cd) {
      //앱 설치링크로 이동
      openMagamartMall("goods", cd);
      // location.href = `csrmegamart://internal-url?close=N&new=Y&url=http://www.megamart.com/product/${cd}&d=&top=1`;
    } else {
      //해당 상품은 오프라인에서만 구매 가능합니다.
      setOpen(true);
    }
  };

  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
    } else if (alertOpen) {
      dispatch(loadAlert(false));
    } else {
      history.goBack();
    }
  };

  const checkImgSize = (url) => {
    let img = new Image();
    img.src = url;
    img.onload = async function() {
      setDescImgChecked(Number(img.height) / 3 >= 800);
    };
  };

  return (
    <>
      <Loading open={fetching} />
      <PullToRefresh
        onRefresh={loadDetail}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <main
          id="main"
          className={classes.productWeek + " productOfWeekDetail"}
        >
          <div className="product-info">
            <div className="product-img">
              <div className="img-wrap">
                <img src={detailData.prodImgUrl} />
              </div>
              {detailData.dcMak && (
                <div className="badge">
                  <div className="txt">{detailData.dcMak}</div>
                </div>
              )}
              <div className="fav-btn">
                <Button
                  className="fav"
                  onClick={() => {
                    handleFav();
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/favorite${
                      detailData.favYn == "Y" ? "" : "-off-d"
                    }.svg`}
                  />
                  <span
                    style={{
                      color: detailData.favYn == "Y" ? "#F1270B" : "#8e8e8e",
                    }}
                  >
                    {detailData.favCnt}
                  </span>
                </Button>
              </div>
            </div>
            <div className="txt-wrap">
              <div className="tit">{detailData.ttl}</div>
              {detailData.prchTrms && (
                <div className="sub-tit">{detailData.prchTrms}</div>
              )}
              <div className="price-wrap">
                <div className="price">
                  {detailData.prc && detailData.prc.toLocaleString()}
                  <span>원</span>
                </div>
                {detailData.prcBefDc && (
                  <div className="price-before">
                    {detailData.prcBefDc.toLocaleString()}원
                  </div>
                )}
              </div>
              {detailData.dcTp && (
                <div className="grey-box">{detailData.dcTp}</div>
              )}
              {detailData.prmtCont && (
                <div className="red-box">{detailData.prmtCont}</div>
              )}
              {detailData.qty && (
                <div className="cnt">
                  한정수량 {detailData.qty.toLocaleString()}개
                </div>
              )}
            </div>
          </div>
          <div className="product-desc">
            <ul className="list list-dot color-info font-14">
              {renderNoti(detailData.prodCnt).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          {detailData.prodDescImgUrl ? (
            <div className="product-contents">
              {descImgChecked ? (
                <Collapse in={checked} collapsedSize={800}>
                  <img src={detailData.prodDescImgUrl} />
                  <div
                    className={
                      checked === true ? "btn-wrap" : "btn-wrap fade-box"
                    }
                  >
                    <Button
                      variant="outlined"
                      color="info"
                      className="btn-rounded end-icon btn-detail"
                      size="small"
                      endIcon={<i className="ico-go" />}
                      onClick={() => {
                        setChecked((prev) => !prev);
                      }}
                    >
                      상세정보 {checked === true ? "닫기" : "더 보기"}
                    </Button>

                    {(!favInfo || favInfo.visibleTp !== "2") && (
                      <Button
                        className="main-btn"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          buyItem(detailData.repProdCd);
                        }}
                      >
                        온라인몰에서 상품 보기
                      </Button>
                    )}
                  </div>
                </Collapse>
              ) : (
                <>
                  <img src={detailData.prodDescImgUrl} />{" "}
                  {(!favInfo || favInfo.visibleTp !== "2") && (
                    <div className="short-img-btn-wrap">
                      <Button
                        className="main-btn"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          buyItem(detailData.repProdCd);
                        }}
                      >
                        온라인몰에서 상품 보기
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          ) : (
            <>
              {(!favInfo || favInfo.visibleTp !== "2") && (
                <div className="btn-wrap">
                  <Button
                    className="main-btn"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      buyItem(detailData.repProdCd);
                    }}
                  >
                    온라인몰에서 상품 보기
                  </Button>
                </div>
              )}
            </>
          )}
          {detailData.prodTp == "1" && (
            <ReviewComment buyYn={detailData.buyYn} />
          )}
          {detailData.noti && (
            <Box className="box-type-9">
              <Box className="notice">
                <p className="title">
                  <i className="ico-noti" />
                  유의사항
                </p>
                <ul className="list list-dot color-info font-14">
                  {renderNoti(detailData.noti).map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </Box>
            </Box>
          )}
        </main>
      </PullToRefresh>
      <AlertComplete
        open={open}
        handleAlertClose={handleAlertClose}
        text={"오프라인 전용 상품입니다."}
        action={() => {
          handleAlertClose();
        }}
      />
    </>
  );
}
